module.exports = __webpack_public_path__ + "img/img2.3601ba8d.jpg";